<template>
    <BaseTemplate >
        <div class="bg_white pt16 pb16 pl16 pr16 boxs1">
            
        </div>
    </BaseTemplate>
  </template>

<script>
import SalonApi from '@/components/api/salon/reservation'
import BaseTemplate from '@/views/common/BaseTemplate.vue';
import SidebarTitle from '@/components/common/SidebarTitle.vue'

export default {
    components: {
        BaseTemplate,
        SidebarTitle
    },
    data() {
        return {
            headerList: [],
            dataList: [],
        }
    },
    methods: {
        async apiGetAvailabilityStatusTable() {
            const reservationDate = this.$route.query.reservationDate;
            const salonId = this.$route.query.salonId;
            console.log(reservationDate);
            console.log(salonId);
            await SalonApi.getAvailabilityStatusTable(reservationDate, salonId).then((val) => {
                console.log(val);
                this.headerList = val.headerList;
                this.dataList = val.dataList;
            });
        },
    },
    async created() {
        await this.apiGetAvailabilityStatusTable();
    },
}
</script>

<style lang="css" scoped>
table {
    text-align: center;
    width: 100%;
}
thead th {
    font-size: 14px;
    height: 65px;
    padding: 0;
    text-align: center;
    width: 24%;
}
.table_head {
    display: block;
    padding: 10px;
    width: 100%;
}
thead:after {
    display: block;
    content: '';
    height: 6px;
    background: #fff; /* 背景色はテーブルと同じにします */
    border-bottom: 1px solid #fff; /* ボーダーもテーブルと同じ色にします */
}

tbody tr:nth-child(2n) {
    border-bottom: 2px solid #A2A2A2;
}

th,td {
    border: 1px solid #A2A2A2;
    line-height: 1;
    padding: 15px 0;
}
td.not_empty {
    background-color: #ECECEC;
}
</style>



// WEBPACK FOOTER //
// src/views/salon/AvailabilityStatus.vue